'use strict';

export const USER_TODO_LIST_NAME = 'userTodos';
export const USER_TODO_LIST_PREFIX = `@@${USER_TODO_LIST_NAME}`;



// WEBPACK FOOTER //
// ./src/js/todo-messages/redux/state.js